export const isStringArray = (array: unknown[]): boolean => {
  return Array.isArray(array) && array.every((element) => typeof element === 'string');
};

export const hasWebNavigationWithinPage = (): boolean => {
  const ALL_COMPONENT_IDS = Array.from(document.querySelectorAll('[id]')).map((element) => element.id);
  return ALL_COMPONENT_IDS.includes('web-navigation');
};
